import React, { useState } from "react";
import {
  Card,
  CardBody,
  Label,
  FormGroup,
  Row,
  Input,
  Container,
  CardHeader,
  CardFooter,
  Button,
  Form, FormFeedback
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import axios from 'axios';
import SimpleHeader from "components/Headers/SimpleHeader.js";

export default function CreateType() {
  const token = localStorage.token;
  const [type, setType] = useState("");
  const [typeError, setTypeError] = useState(null);
  let history = useHistory();
  const [isLoading, setLoading] = useState(false);

  const [typeDuplicate, setTypeDuplicate] = useState(null);

  const validateForm = () => {
    let error = false;
    if (type === "") {
      setTypeError("invalid");
      error = true;
    }
    return error;
  };

  function CreateData() {
    setLoading(true);
    let data = {
      terminalTypeName: type
    }
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/terminaltype/save`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then(function (response) {
        if (response.data.error) {
          showErrors(response.data.error);
          return;
        }
        history.push("/admin/type");
      })
      .then(json => {
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error)
      })
  }
  const showErrors = (error) => {
    let errors = false;
    if (error.error_message) {
      setTypeError("invalid");
      setTypeDuplicate(error.error_message);
      errors = true;
    }
    return errors;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      CreateData();
    }
  }
  return (
    <>
      <SimpleHeader name="Daftar Terminal Type" parentName="Admin" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardBody>
                <Form onSubmit={handleSubmit} >
                  <CardHeader>
                    <h3>Daftar Terminal Type</h3>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="type"
                      >
                        Nama Terminal Type
                                            </Label>
                      <Input
                        type="text"
                        name="nama_type"
                        placeholder="Masukan Nama Type"
                        value={type}
                        invalid={typeError === "invalid"}
                        onChange={(e) => {
                          setType(e.target.value);
                          if (e.target.value !== "") {
                            setTypeError("");
                          }
                        }}
                      />
                      <FormFeedback>
                        {
                          type === "" ? "Nama type tidak boleh kosong" : typeDuplicate
                        }
                      </FormFeedback>
                    </FormGroup>
                  </CardBody>
                  <CardFooter>
                    {!isLoading && (<Button color="primary" type="submit">
                      Simpan
                    </Button>)}
                    {isLoading && (<Button color="primary" disabled>
                      <i className="fas fa-spinner fa-spin"></i>{""}
                      loading...
                    </Button>)}
                    <Link className="btn btn-info" to="/admin/type">
                      Kembali
                    </Link>
                  </CardFooter>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
